const catalogFilter = () => {
	if(document.querySelector('[data-btn="mob-filter"]') && document.querySelector('[data-block="filter-block"]')) {
		let mobFilterBtn = document.querySelector('[data-btn="mob-filter"]'),
			mobFilterContent = document.querySelector('[data-block="filter-block"]');
			// footer = document.querySelector('.footer-wrap');
			// div = document.createElement('div');

			// div.classList.add('overlay');

		mobFilterBtn.addEventListener('click', ()=>{
			mobFilterContent.classList.add('active');
			mobFilterContent.classList.add('fade-in-left');

			// footer.appendChild(div);

			addEventListener('click', closeWindow);
			document.body.style.overflow = 'hidden';
		});

		

		function closeWindow(e) {
			let target = e.target;

			if(!mobFilterContent.contains(target) && !target.classList.contains('mob-filter-btn')) {
				mobFilterContent.classList.remove('active');
				removeEventListener('click', closeWindow);
				// footer.removeChild(document.querySelector('.overlay'));
				document.body.style.overflow = 'auto';
			}

			if(target.classList.contains('close-filter')) {
				mobFilterContent.classList.remove('active');
				removeEventListener('click', closeWindow);
				// footer.removeChild(document.querySelector('.overlay'));
				document.body.style.overflow = 'auto';
			}
		}
	}

	// аккордеон для фильтра
	if(document.querySelector('[data-block="filter-block"]')) {
		let filterBlock = document.querySelector('[data-block="filter-block"]');

		filterBlock.addEventListener('click', (e)=>{
			let target = e.target;

			if(target.classList.contains('title') && target.parentNode.querySelector('.item__content')) {
				let contentBlock = target.parentNode.querySelector('.item__content');

				if(target.classList.contains('active')) {
					target.classList.remove('active');
					target.parentNode.classList.remove('open');
					contentBlock.classList.remove('active');
					contentBlock.style.height = '0px';
				} else {
					target.classList.add('active');
					contentBlock.classList.add('active');
					target.parentNode.classList.add('open');
					contentBlock.style.height = contentBlock.scrollHeight + 15 + 'px';
				}
			}
		});
	}
};


export default catalogFilter;
